import { render, staticRenderFns } from "./ModifySchoolDeliveryModal.vue?vue&type=template&id=b795eb2c"
import script from "./ModifySchoolDeliveryModal.vue?vue&type=script&lang=ts"
export * from "./ModifySchoolDeliveryModal.vue?vue&type=script&lang=ts"
import style0 from "./ModifySchoolDeliveryModal.vue?vue&type=style&index=0&id=b795eb2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports